export default __webpack_public_path__ + "static/media/instagram-2.0c674cde.jpeg";